import React, { Component } from 'react';

const APP_ROUTE_GROUPS = [
  {
    group: 'Program',
    routes: [
      { name: 'Program Hub Screen', value: 'programHubScreen' },
      { name: 'Schedule', value: 'schedule' },
      { name: 'Category', value: 'category' },
      { name: 'Genre', value: 'genre' },
      { name: 'Venue', value: 'venue' },
      { name: 'All Films', value: 'allFilms' },
      { name: 'All Events', value: 'allEvents' },
      { name: 'Film Or Event Details', value: 'filmOrEventDetails' },
      { name: 'Buy Tickets', value: 'buyTickets' },
    ],
  },
  {
    group: 'My Fest',
    routes: [
      { name: 'My Fest Hub Screen', value: 'myFestHubScreen' },
      { name: 'Tickets', value: 'tickets' },
      { name: 'Festival ID', value: 'festivalID' },
      { name: 'My Schedule', value: 'mySchedule' },
      { name: 'My Waitlist', value: 'myWaitlist' },
      { name: 'My Favorites', value: 'myFavorites' },
      { name: 'My Viewing Room', value: 'myViewingRoom' },
      { name: 'My Gifts & Transfers', value: 'myGiftsTransfers' },
      { name: 'My Account', value: 'myAccount' },
    ],
  },
  {
    group: 'Guides',
    routes: [
      { name: 'Guides Hub Screen', value: 'guidesHubScreen' },
      { name: 'Guides Venues', value: 'guidesVenues' },
      { name: 'Press & Industry', value: 'press' },
      { name: 'Festival Map', value: 'festivalMap' },
      { name: 'How to Fest', value: 'howToFest' },
      { name: 'Accessibility', value: 'accessibility' },
      { name: 'Contact Us', value: 'contactUs' },
      { name: 'Lodging', value: 'lodging' },
    ],
  },
  {
    group: 'More',
    routes: [
      { name: 'More Hub Screen', value: 'moreHubScreen' },
      { name: 'Highlights', value: 'highlights' },
      { name: 'Sponsors', value: 'sponsors' },
      { name: 'Shop', value: 'shop' },
      { name: 'Web', value: 'web' },
    ],
  },
];

/**
 * AppRoutePicker
 *
 * Reusable input + floating route-picker dropdown for Mobile App "App Page" fields.
 * Stores the route key (e.g. "programHubScreen") as the value; shows the path as context.
 *
 * Props:
 *   value       {string}  — current route key
 *   onChange    {fn}      — called with the selected route key string
 *   inputClass  {string}  — optional extra class for the <input>
 *   error       {node}    — optional validation error node
 *   placeholder {string}  — input placeholder override
 */
class AppRoutePicker extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.wrapRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(e) {
    if (this.wrapRef.current && !this.wrapRef.current.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  select(key) {
    this.props.onChange('/' + key);
    this.setState({ open: false });
  }

  render() {
    const { value, onChange, inputClass, error, placeholder } = this.props;
    const { open } = this.state;

    return (
      <div className="sd_route_picker_wrap" ref={this.wrapRef}>
        <div className="sd_route_input_row">
          <input
            type="text"
            className={`sd_route_picker_input${inputClass ? ` ${inputClass}` : ''}`}
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder || 'Select a route or type key...'}
            autoComplete="off"
          />
          <button
            type="button"
            className="sd_route_picker_btn"
            onClick={() => this.setState(prev => ({ open: !prev.open }))}
            title="Browse app routes"
          >
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
              <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {open && (
          <div className="sd_route_picker_dropdown">
            {APP_ROUTE_GROUPS.map(grp => (
              <div key={grp.group} className="sd_route_group">
                <p className="sd_route_group_label">{grp.group}</p>
                {grp.routes.map(route => (
                  <button
                    key={route.value}
                    type="button"
                    className={`sd_route_item${value === '/' + route.value ? ' active' : ''}`}
                    onClick={() => this.select(route.value)}
                  >
                    <span className="sd_route_item_name">{route.name}</span>
                    <span className="sd_route_item_path">{'/' + route.value}</span>
                  </button>
                ))}
              </div>
            ))}
          </div>
        )}

        {error && <span className="sd_route_picker_error">{error}</span>}
      </div>
    );
  }
}

export default AppRoutePicker;
